import { compilePath, createRouter, PathParam, Instance } from '@funtech-int/rival';
import { createApplication } from '@funtech-int/rival-react';

import purchases, { purchasesRoute } from '@/scenarios/purchases';
import home, { mainRoute } from '@/scenarios/home';
import profiles, { profilesRoute, adminFamilyAddRoute } from '@/scenarios/profiles';
import person, { personRoute } from '@/scenarios/person';
import selection, { selectionRoute } from '@/scenarios/selection';
import movie, { filmRoute } from '@/scenarios/movie';
import channels, { channelsRoute } from '@/scenarios/channels';
import settings, { settingsRoute } from '@/scenarios/settings';
import personal, { historyRoute, personalRoute } from '@/scenarios/personal';
import faq from '@/scenarios/faq';
import showcase, { showcaseRoute } from '@/scenarios/showcase';
import player, { playerRoute } from '@/scenarios/player';
import notifications from '@/scenarios/notifications';
import suggest from '@/scenarios/suggest';
import sport, { sportRoute } from '@/scenarios/sport';
import { ErrorFallback } from '@/shared/components/ErrorFallback/ErrorFallback';
import { Layout } from '@/app/components/Layout/Layout';
import { runtimeConfig } from '@/shared/lib/runtimeConfig';

interface AppFactoryContext {
    dependencies?: Instance<any>[];
    featureFlagsData?: Record<string, boolean>;
}
export function appFactory({ dependencies = [], featureFlagsData }: AppFactoryContext) {
    const { localeState } = runtimeConfig.get();
    const basename = !localeState.isFallbackLocale ? `/${localeState.locale}` : undefined;
    const router = createRouter({ basename, enableRouteKey: true });

    router
        .add(compilePath('/'), mainRoute)
        .add(compilePath('/movies/channels'), channelsRoute)
        .add(compilePath('/movies/film/:id', { id: PathParam.string }), filmRoute)
        .add(compilePath('/movies/history'), historyRoute)
        .add(compilePath('/movies/person/:id', { id: PathParam.string }), personRoute)
        .add(compilePath('/movies/personal'), personalRoute)
        .add(compilePath('/movies/profiles'), profilesRoute)
        .add(compilePath('/movies/purchases'), purchasesRoute)
        .add(compilePath('/movies/selection/:id', { id: PathParam.string }), selectionRoute)
        .add(compilePath('/movies/settings'), settingsRoute)
        .add(compilePath('/movies/admin-family-add'), adminFamilyAddRoute)
        .add(compilePath('/movies/showcase/:id', { id: PathParam.string }), showcaseRoute)
        .add(compilePath('/play/:contentId', { contentId: PathParam.string }), playerRoute);

    const scenarios = [
        home,
        profiles,
        person,
        selection,
        purchases,
        movie,
        channels,
        settings,
        personal,
        faq,
        showcase,
        player,
        notifications,
        suggest,
    ];

    if (featureFlagsData && featureFlagsData.sportEnabled) {
        router.add(compilePath('/sport'), sportRoute);
        scenarios.push(sport);
    }

    const app = createApplication({
        layout: Layout,
        fallback: ErrorFallback,
        scenarios,
    });

    dependencies.concat(router).forEach((dependency) => app.set(dependency));

    return app;
}
